export default {"src":"/_next/static/media/medal.3007b955.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};